export const DIALOG_DEFAULT_WIDTH = "400px"
